import React from "react";
import Particles from "react-particles-js";
import { makeStyles } from "@material-ui/core/styles";

import NavBar from "./navBar";
import Header from "./header";

//CSS styling
const useStyles = makeStyles({
  particlesCanvas: {
    position: "absolute",
    opacity: "0.3",
  },
});

const Index = (props) => {
  const classes = useStyles();

  return (
    <div style={{ height: "100%" }}>
      <NavBar />
      <Header />
      <Particles
        canvasClassName={classes.particlesCanvas}
        params={{
          particles: {
            number: {
              value: 60,
              density: {
                enable: true,
                value_area: 900,
              },
            },
            shape: {
              type: "circle",
              stroke: {
                width: 1,
                color: "#6f2232",
              },
            },
            size: {
              value: 8,
              random: true,
              anim: {
                enable: true,
                speed: 5,
                size_min: 0.1,
                sync: true,
              },
            },
            opacity: {
              value: 1,
              random: true,
              anim: {
                enable: true,
                speed: 1,
                opacity_min: 0.1,
                sync: true,
              },
            },
          },
        }}
      />
    </div>
  );
};

export default Index;
